import { render, staticRenderFns } from "./SendSurvey.vue?vue&type=template&id=39fa9f8a&scoped=true&"
import script from "./SendSurvey.vue?vue&type=script&lang=js&"
export * from "./SendSurvey.vue?vue&type=script&lang=js&"
import style0 from "./SendSurvey.vue?vue&type=style&index=0&id=39fa9f8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fa9f8a",
  null
  
)

export default component.exports